<h2 mat-dialog-title>
  {{ "brand.campaign.content.movePostCategory.dialogTitle" | translate }}
</h2>
<mat-dialog-content>
  <div class="select-category-text">
    {{
      "brand.campaign.content.movePostCategory.selectCategoryText" | translate
    }}
  </div>
  <div class="category-selection">
    <div class="available-categories">
      {{
        "brand.campaign.content.movePostCategory.availableCategories"
          | translate
      }}
    </div>
    <div *ngFor="let category of categories" class="move-to-category-select">
      <div
        class="move-to-category-select__option"
        (click)="selectCategory(category)"
        [ngClass]="{
          active: isCategorySelected(category),
          clickable: !isCategorySelected(category)
        }"
      >
        <span class="move-to-category-select__option__text">{{
          category.title
        }}</span>
        <mat-icon
          *ngIf="isCategorySelected(category)"
          class="move-to-category-select__option__check"
          >check</mat-icon
        >
      </div>
    </div>
  </div>
  <div *ngIf="categories.length === 0" class="no-categories">
    {{
      "brand.campaign.content.movePostCategory.noCategoriesFound" | translate
    }}
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn--transparent" tabindex="-1" [mat-dialog-close]="">
    {{ "shared.cancel" | translate }}
  </button>
  <button
    class="btn btn--primary"
    (click)="move()"
    [disabled]="isMoveButtonDisabled()"
  >
    <span *ngIf="moving">{{
      "brand.campaign.content.movePostCategory.movingButton" | translate
    }}</span>
    <span *ngIf="!moving">{{
      "brand.campaign.content.movePostCategory.moveButton" | translate
    }}</span>
  </button>
</mat-dialog-actions>
